import React, { useRef, PropsWithChildren } from 'react';
import { useForm, SubmitHandler, FormProvider } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers';
import { ObjectSchema } from 'yup';
import AnimateHeight from 'react-animate-height';
import useVisible from 'src/util/hooks/use-visible';
import { DevTool } from '@hookform/devtools';
import { DeepPartial } from 'react-hook-form/dist/types/utils';
import { UnpackNestedValue } from 'react-hook-form/dist/types/form';

interface IFormProps<T> {
    className?: string;
    style?: React.CSSProperties;
    onSubmit: (values: T) => void;
    defaultValues?: UnpackNestedValue<DeepPartial<T>>;
    validationSchema?: ObjectSchema;
    showDevTools?: boolean;
    onFormUpdated?: (values: T) => void;
    showHeader?: boolean;
    submitButtonText?: string;
    showSubmitButton?: boolean;
}

const FormHeader: React.FC = (props) => <div {...props} />;
FormHeader.displayName = 'FormHeader';

// tslint:disable-next-line: whitespace
const Form = <T,>(props: PropsWithChildren<IFormProps<T>>) => {
    const formMethods = useForm<T>();
    // const formMethods = useForm<T>({ defaultValues: props.defaultValues });

    const { isDirty } = formMethods.formState;

    const savePanelRef = useRef(null);
    // Account for spacing of the main nav bar.
    const savePanelVisible = useVisible(savePanelRef, '-51px 0px 0px 0px', 1);

    let style: React.CSSProperties = undefined;
    let style2: React.CSSProperties = undefined;

    if (isDirty) {
        style = {
            position: 'relative',
            background: '#f1f1f1',
        };
        style2 = {
            padding: '1rem',
            background: '#F4EAEA',
        };
        style = { ...style, ...props.style };
        style2 = { ...style2, ...props.style };
    } else {
        style = {
            position: 'relative',
            borderTop: '2px solid transparent',
            background: 'auto',
        };
        style2 = {
            padding: '1rem',
            border: '0 solid transparent',
            borderBottom: '2px solid #ccc',
            background: '#fcfcfc',
        };
        style = { ...style, ...props.style };
        style2 = { ...style2, ...props.style };
    }

    const handleChange = () => {
        if (props.onFormUpdated) {
            props.onFormUpdated(formMethods.getValues() as T);
        }
    };

    const formSubmit: SubmitHandler<T> = (data) => {
        props.onSubmit(data as T);
    };

    return (
        <>
            <FormProvider {...formMethods}>
                <form onChange={handleChange} style={style} onSubmit={formMethods.handleSubmit(formSubmit)}>
                    <AnimateHeight
                        height={isDirty && props.showHeader ? 'auto' : '0%'}
                        duration={250}
                        style={{
                            position: 'sticky',
                            top: '59px',
                            zIndex: 1,
                            textAlign: 'center',
                            borderTopWidth: '2px',
                            borderTopStyle: 'solid',
                            marginTop: '-2px',
                            borderTopColor: isDirty && props.showHeader ? '#6293C1' : 'transparent',
                        }}
                    >
                        <div style={{ background: '#6293C1', color: 'white', fontWeight: 'bold', padding: '0 8px 3px', width: '100%' }}>
                            You have unsaved changes.
                            {!savePanelVisible && <span>Save Button</span>}
                        </div>
                    </AnimateHeight>
                    <div>
                        <FormHeader />
                    </div>
                    <div>{props.children}</div>
                    {props.showSubmitButton && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <input className="btn" type="submit" value={props.submitButtonText} />
                        </div>
                    )}
                </form>
            </FormProvider>

            {props.showDevTools && <DevTool control={formMethods.control} />}
        </>
    );
};

Form.defaultProps = {
    showDevTools: false,
    showHeader: true,
    showSubmitButton: false,
    submitButtonText: 'Submit',
};

Form.Header = FormHeader;

export default Form;



// WEBPACK FOOTER //
// ./src/components/controls/forms/reactHookForm/Form.tsx